module.exports = __webpack_public_path__ + "static/media/pin_red.04f49dfd.svg";